import { RestrictionType } from '@mews-commander/data-access';
import { TooltippedSpan } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { useCommanderSelector } from '@mews-commander/utils';
import { RESTRICTION_TYPE_LABEL_MAP } from '../../../constants';
import {
    getFirstConditionCellLabelVariants,
    getSecondConditionCellLabelVariants,
    shouldAddBorderToRateCell,
    shouldAddBorderToSpaceCell,
} from '../../../selectors';
import { CloseTypeCellElement } from '../styles';
import { RestrictionCalendarRow } from '../../../types';
import { MatrixCellWrapperElement } from '../../../../../components/commander-ui/Matrix';
import AsideCellLabel from './AsideCellLabel';

interface OwnProps {
    type: RestrictionType;
    restrictionCalendarRows: Array<RestrictionCalendarRow>;
    rowIndex: number;
    serviceId: string;
}

type RestrictionsAsideCellProps = OwnProps;

const RestrictionsAsideCell = ({ type, restrictionCalendarRows, ...matrixCellProps }: RestrictionsAsideCellProps) => {
    const { conditions } = restrictionCalendarRows[matrixCellProps.rowIndex];
    const restrictionRowConditions = restrictionCalendarRows.map((row) => row.conditions);
    const sharedProps = { ...matrixCellProps, conditions };

    const firstCellLabelVariants = useCommanderSelector((state) =>
        // @ts-expect-error
        getFirstConditionCellLabelVariants(state, {
            conditions: restrictionRowConditions,
            rateId: conditions.rateId,
            rateGroupId: conditions.rateGroupId,
            serviceId: matrixCellProps.serviceId,
            rowIndex: matrixCellProps.rowIndex,
        })
    );

    const firstCellBorder = useCommanderSelector((state) =>
        shouldAddBorderToRateCell(state, {
            conditions: restrictionRowConditions,
            rowIndex: matrixCellProps.rowIndex,
            serviceId: matrixCellProps.serviceId,
            matrixRowCount: restrictionCalendarRows.length,
        })
    );

    const secondCellLabelVariants = useCommanderSelector((state) =>
        // @ts-expect-error
        getSecondConditionCellLabelVariants(state, {
            conditions: restrictionRowConditions,
            resourceCategoryId: conditions.resourceCategoryId,
            resourceCategoryType: conditions.resourceCategoryType,
            serviceId: matrixCellProps.serviceId,
            rowIndex: matrixCellProps.rowIndex,
        })
    );

    const secondCellBorder = useCommanderSelector((state) =>
        shouldAddBorderToSpaceCell(state, {
            conditions: restrictionRowConditions,
            rowIndex: matrixCellProps.rowIndex,
            serviceId: matrixCellProps.serviceId,
        })
    );

    return (
        <MatrixCellWrapperElement {...sharedProps}>
            <AsideCellLabel
                borderBottom={firstCellBorder}
                defaultLabelTextKey={TextKey.AllRates}
                labelVariants={firstCellLabelVariants}
                {...sharedProps}
                bold
            />
            <AsideCellLabel
                borderBottom={secondCellBorder}
                defaultLabelTextKey={TextKey.AllSpaces}
                labelVariants={secondCellLabelVariants}
                {...sharedProps}
                borderLeft
            />
            <CloseTypeCellElement {...sharedProps} itemAlignment="center">
                {/* @ts-expect-error $TSFixMeError */}
                <TooltippedSpan tooltip={<LocalizedText textKey={type} />}>
                    {RESTRICTION_TYPE_LABEL_MAP[type]}
                </TooltippedSpan>
            </CloseTypeCellElement>
        </MatrixCellWrapperElement>
    );
};

export default RestrictionsAsideCell;
